import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import {
  onMounted,
  onBeforeUnmount,
  onBeforeMount,
  computed,
  ref,
  onBeforeUpdate,
} from 'vue';
import { useStore } from 'vuex';
import SidebarGroup from '@/components/sidebar/SidebarGroup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IoSidebar',
  props: {
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



const store = useStore();
const sidebarGroups = ref<InstanceType<typeof SidebarGroup>[]>([]);

const setPosAndHeight = () => {
  const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
  const $header = document.querySelector('header') as HTMLElement;
  const $sidebar = document.querySelector('#sidebar') as HTMLElement;

  let top = 0;

  if ($wpAdminBar) {
    top += $wpAdminBar.scrollHeight;
  }
  if ($header) {
    top += $header.offsetHeight;
  }

  if ($sidebar) {
    $sidebar.style.top = `${top}px`;
    $sidebar.style.height = `${window.innerHeight - top}px`;
  }
};

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'sidebar');
});

onBeforeUpdate(() => {
  sidebarGroups.value = [];
});

const isOpen = computed(() => store.getters['sidebar/open']);

onMounted(() => {
  window.addEventListener('resize', setPosAndHeight);
  window.addEventListener('load', setPosAndHeight);
  setPosAndHeight();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(setPosAndHeight, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosAndHeight);
  window.removeEventListener('load', setPosAndHeight);
});

const closeOther = (keepInx: number) => {
  sidebarGroups.value.forEach((sidebarGroup, groupInx) => {
    if (groupInx !== keepInx) {
      sidebarGroup.close();
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    id: "sidebar",
    class: _normalizeClass({'open': isOpen.value})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createBlock(SidebarGroup, {
        key: `sg-1-${index}`,
        level: 1,
        index: index,
        item: item,
        ref_for: true,
        ref: el => { if (el) sidebarGroups.value[index] = el },
        onOpen: ($event: any) => (closeOther(index))
      }, null, 8, ["index", "item", "onOpen"]))
    }), 128))
  ], 2))
}
}

})